import { makeStyles } from '@material-ui/core/styles';

export default function ProdutoCardCss() {
    return makeStyles(theme => ({
        root: {
            flexGrow: 1,
        },
        menuButton: {
            marginRight: theme.spacing(2),
        },
        title: {
            flexGrow: 1,
        },
    }));
}